import { useEffect, useState } from "react";
import Page from "../layout/Page";
import { useMsal } from "@azure/msal-react";
import { Grid, Typography } from "@mui/material";
import { useRole } from "../auth/role";

export default function HomePage(props = {}) {
  const { instance } = useMsal();
  const [account, setAccount] = useState(instance.getActiveAccount());
  const { role } = useRole();

  // useEffect(() => {
  //   setAccount(instance.getActiveAccount())
  // },[instance, role])

  return (
    <Page {...props}>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Typography variant="h4" gutterBottom>
            PFAS Home
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <span>Name: {account?.name || "null"}</span>
        </Grid>
        <Grid item xs={12}>
          <span>Username: {account?.username || "null"}</span>
        </Grid>
        <Grid item xs={12}>
          <span>Email: {account?.idTokenClaims.mail || "null"}</span>
        </Grid>
        <Grid item xs={12}>
          <span>Department: {account?.idTokenClaims.department || "N/A"}</span>
        </Grid>
        <Grid item xs={12}>
          <span>PFAS Role: {role?.name}</span>
        </Grid>
      </Grid>
    </Page>
  );
}
